import axios from '../../../utils/axios';
import { GetStorageComponent } from '../../../utils/storage';
import { AxiosRequestConfig } from 'axios';
import { showError, showSuccess } from '../../../utils/alertNotification';
import * as types from './types';
import { ProfileStateType } from './state';
import { asyncFunc } from '../../../utils/asyncFunctionUtils';

export const getProfile = () => async (dispatch: any): Promise<any> => {
  const [err, data] = await asyncFunc({
    method: 'get',
    url: `api/v2/profiles/profile`,
    'noRetry': true,
  })
  if (err) {
    throw (err);
  } else {
    dispatch({ type: types.PROFILE_GET, payload: data });
    return (data);
  }
};

export const putProfileInfo = (values: ProfileStateType) => (dispatch: any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  return new Promise((resolve, reject) => {
    axios.request({
      method: 'PUT',
      url: `/api/v2/profiles/profile/basic`,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
      data: values,
      'noRetry': true,
    } as AxiosRequestConfig).then((response) => {
      dispatch({
        type: types.PROFILE_GET,
        payload: response.data
      });
      showSuccess('Profile Updated Successfully');
      resolve();
    }).catch((err) => {
      if (err && err.data) {
        showError(err.data.message);
      }
      reject();
    });
  })
};

export const CVUpload = (options: any) => (dispatch: any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  let formdata = new FormData();
  formdata.append('resume', options.file);

  return axios.request({
    method: 'POST',
    url: `/applications/application/resume`,
    data: formdata,
    headers: {
      Authorization: 'bearer ' + accessToken
    },
  });
};

export interface ImageUploadOptions {
  fileContent: any;
  fileName: string;
  fileExtension: string;
}

export const ImageUpload = (options: ImageUploadOptions) => {
  return () => {
    const accessToken = GetStorageComponent('access_token');
    return axios.request({
      method: 'POST',
      url: `profiles/profile/imageupload`,
      data: {
        fileContent: options.fileContent,
        fileName: options.fileName,
        fileExtension: '.' + options.fileExtension
      },
      'noRetry': true,
      headers: {
        Authorization: 'bearer ' + accessToken
      },
    } as AxiosRequestConfig);
  };
};

export const ImageUploadV2 = (image: any) => {
  return () => {
    const accessToken = GetStorageComponent('access_token');
    return axios.request({
      method: 'POST',
      url: `profiles/profile/image`,
      data: image,
      'noRetry': true,
      headers: {
        Authorization: 'bearer ' + accessToken,
      },
      timeout: 30000
    } as AxiosRequestConfig).catch((e) => {
    });
  };
};
